import { Skeleton } from "@/components/ui/skeleton";
import { SPACING, RESPONSIVE, SKELETONS } from "@/design-system";
import { cn } from "@/lib/utils";

interface ExpertSearchResultSkeletonProps {
  items?: number;
}

export function ExpertSearchResultSkeleton({ items = 3 }: ExpertSearchResultSkeletonProps) {
  return (
    <div className={cn(SPACING.listItemGap, 'p-2')}>
      {[...Array(items)].map((_, i) => (
        <div key={i} className={cn(RESPONSIVE.flexRowCenterGap3, 'p-2')}>
          <Skeleton className={SKELETONS.elements.avatar.sm} />
          <div className={cn(SPACING.listItemGap, 'flex-1')}>
            <Skeleton className={SKELETONS.elements.title.default} />
            <Skeleton className={SKELETONS.elements.subtitle.sm} />
          </div>
        </div>
      ))}
    </div>
  );
}
